import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { FilterCheckboxIcon } from 'apps/sigma2-ui/src/filters-v2/components/FilterCheckboxIcon';
import { FilterItemWrapper } from 'apps/sigma2-ui/src/filters-v2/components/FilterItemWrapper';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export interface FilterCheckableItemProps {
  /**
   * Callback when checked state changes
   * @param newChecked
   */
  onChange: (newChecked: boolean) => void;

  /**
   * The current checked state
   */
  checked: boolean;

  /**
   * The label for the checkable item
   */
  translatedContent: TranslatedContent;

  /**
   * The item value (should be unique) for tracking purposes.
   */
  itemValue: string;
}

export const FilterCheckableItem = ({
  onChange,
  checked,
  translatedContent,
  itemValue,
}: FilterCheckableItemProps) => {
  return (
    <TouchTarget
      content={({ hovered }) => (
        <FilterItemWrapper highlight={hovered}>
          <Spacing
            direction={'horizontal'}
            size={'sm'}
            className={'items-center -ml-2'}
          >
            <FilterCheckboxIcon checked={checked} hovered={hovered} />
            <S2Typography
              variant={'body-7'}
              translatedContent={translatedContent}
              textColorVariant={'gray-900'}
              truncate={true}
              flex={true}
            />
          </Spacing>
        </FilterItemWrapper>
      )}
      behavior={{
        type: 'onClick',
        onClick: () => {
          onChange(!checked);
        },
      }}
      className={'filter-checkable-item'}
      dataExtras={{
        itemValue,
        checked: checked ? '1' : '0',
      }}
    />
  );
};
